import StarterKit from '@tiptap/starter-kit';
import { TextStyle, Color } from '@tiptap/extension-text-style';
import Highlight from '@tiptap/extension-highlight';
import { Blank } from './blankExtension.js';

/**
 * Editor/renderer extension registry. Rendering stored content and editing it
 * share this list, so adding e.g. an image, audio or math node later is one
 * `registerExtension(...)` call plus a toolbar button.
 */
const extra = [];

export function registerExtension(extension) {
  extra.push(extension);
  cached = null;
}

let cached = null;

export function getExtensions() {
  if (!cached) {
    cached = [
      StarterKit.configure({
        heading: { levels: [2, 3] },
        link: { openOnClick: false, autolink: true, HTMLAttributes: { rel: 'noopener noreferrer nofollow', target: '_blank' } },
      }),
      TextStyle,
      Color,
      Highlight.configure({ multicolor: false }),
      Blank,
      ...extra,
    ];
  }
  return cached;
}
